export default {
    set (store) {
        window.AFRAME.store = store;
    },
    reset () {
        window.AFRAME.store = {};
    }
};
